import React, { useMemo, useEffect, useRef } from "react";
import { useHandlebarsTemplate } from "./useHandlebarsTemplate";
import { preprocessInvoice } from "./preprocessInvoice";
import { preprocessProductpageData } from './preprocessProductpageData.js'
// const { preprocessProductpageData } = pp;
export default function TemplatePreview({
  url = "/api/template/invoice",
  previewData,
  currency,
  runscripts = false,
  inIFrame = false
}) {
  const { render, status, error } = useHandlebarsTemplate(url);
  const containerRef = useRef(null);

  const vm = useMemo(() => {
    if (url.endsWith('invoice')){
      if (previewData && currency) {
        return preprocessInvoice(previewData, currency);
      }
    }
    if(url.endsWith('productpage') || url.endsWith('test')){
      return preprocessProductpageData(previewData)
    }
  }, [previewData, currency, url]);

  const html = render ? render(vm) : "";

  useEffect(() => {
    if (inIFrame) return;
    if (!containerRef.current) return;
    if (!html) return;

    containerRef.current.innerHTML = html;
    if(runscripts){
    const scripts = containerRef.current.querySelectorAll("script");

    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      if (oldScript.src) {
        newScript.src = oldScript.src;
      } else {
        newScript.text = oldScript.innerHTML;
      }

      document.body.appendChild(newScript);
      oldScript.remove();

    });
  }
  }, [html, inIFrame]);

  if (status === "loading") return <div>Loading preview…</div>;
  if (status === "error" || !render)
    return <div>Failed to load template {String(error || "")}</div>;

  return inIFrame ? (
    <iframe
      srcDoc={html}
      style={{ width: "100%", border: "none", height: "100%" }}
      sandbox="allow-scripts allow-popups allow-same-origin allow-forms"
    />
  ) : (
    <div id="container" ref={containerRef} style={{ width: "100%", border: "none", height: "90vh" }} />
  );
}
